import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import styles from './Notification.module.css';

export interface NotificationProps {
  className?: string;
  children?: ReactNode;
}

export const Notification: FC<NotificationProps> = ({
  children,
  className,
}) => <div className={clsx(styles.notification, className)}>{children}</div>;
